module.exports = __webpack_public_path__ + "img/code.0ffae005.jpg";